import { create } from "zustand";

const initialState = {
  unreadApplied: false,
  selectedOrgIds: [],
  openApplied: false,
};

export const useContactFiltersStore = create((set, get) => ({
  ...initialState,
  actions: {
    setUnreadApplied: (value) => set({ unreadApplied: value }),
    setSelectedOrgIds: (orgIds) => set({ selectedOrgIds: orgIds }),
    setOpenApplied: (value) => set({ openApplied: value }),
    getAppliedFilters: () => {
      const allState = get();
      return {
        unreadApplied: allState.unreadApplied,
        selectedOrgIds: allState.selectedOrgIds,
        openApplied: allState.openApplied,
      };
    },
    reset: () => set({ ...initialState }),
  },
}));
